<template>
    <div>
        <base-header class="pb-6" type="">
        <b-row class="align-items-center py-4">
            <b-col lg="8" cols="12">
                <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                <h6 class="h2 d-inline-block mb-0">{{ language_terms[$route.name] }}</h6>
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                    <route-breadcrumb />
                </nav>
            </b-col>
        </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <loading :active.sync="loading" 
                color= '#007bff'
                :width= '128'
                :height= '128'
                loader='dots'
                :can-cancel="true" 
                :is-full-page="true">
            </loading>
            <b-row>
                <b-col cols="12">
                    <div class="card-wrapper">
                        <card>
                            <div slot="header" class="mb-0">
                                <b-row>
                                    <b-col lg="6">
                                        <div>
                                            <span style="font-weight: bold">{{ document_title }} </span>
                                        </div>
                                    </b-col>
                                    <b-col lg="6">
                                        <base-button icon type="success" class="float-right mr-4" @click="editDocument"  v-if="(is_edit == 0 && receipt.is_void != '1' && receipt.time_printed == null)">
                                            <i class="fas fa-edit"></i>
                                        </base-button>
                                        <printDocument :data="receipt" class="float-right mr-4" v-if="$route.params.id != '_new'"></printDocument> 
                                        <base-button icon type="warning" class="float-right mr-4" @click="voidDocument"  v-if="($route.params.id != '_new' && receipt.is_void != '1' && receipt.time_printed == null)">
                                            {{language_terms['VOID']}}
                                        </base-button>
                                        <i class="fa fa-exclamation-triangle float-right text-red fa-3x" v-if="receipt.is_void == '1'" ></i>
                                    </b-col>
                                </b-row>
                            </div>
                            <b-row>
                                <b-col lg="6" cols="12">
                                    <label class="form-control-label">{{language_terms["CUSTOMER"]}}</label>
                                        <base-input v-model="receipt.contact_name" v-if="(!is_edit || $route.params.id != '_new')" disabled></base-input>
                                        <multiselect
                                            v-else
                                            :internalSearch = "false"
                                            v-model="receipt.customer"
                                            ref="multiselcetRef"
                                            label="name"
                                            track-by="id"
                                            placeholder="Type to search"
                                            open-direction="bottom"
                                            :preserve-search="false"
                                            :options="customers"
                                            :multiple="false"
                                            :searchable="true"
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :options-limit="300"
                                            :limit="50"
                                            :limit-text="limitText"
                                            :max-height="600"
                                            :show-no-results="false"
                                            :hide-selected="false"
                                            @search-change="asyncFindCustomer"
                                            @input="onSelectCustomer"
                                            >
                                        </multiselect>
                                </b-col>
                                <b-col md="6">
                                    <base-input :label="language_terms['DATE']" v-if="is_edit">
                                        <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        style="background-color: white"
                                        class="form-control datepicker"
                                        v-model="receipt.date">
                                        </flat-picker>
                                    </base-input>
                                    <base-input
                                        :label="language_terms['DATE']"
                                        v-model="receipt.date"
                                        v-if="!is_edit"
                                        type="date"
                                        disabled
                                    ></base-input>
                                    </b-col>
                                <b-col lg="2">
                                    <base-input v-model="receipt.currency_code" :label="language_terms['CURRENCY_CODE']" disabled></base-input>
                                </b-col>
                                <b-col lg="2">
                                    <base-input :label="language_terms['BANK_ACCOUNT']">
                                        <el-select
                                            v-model="receipt.bankaccount_id"
                                            filterable
                                            :placeholder="language_terms['BANK_ACCOUNT']"
                                            :disabled="!is_edit">
                                            <el-option
                                                v-for="option in company_bankaccounts"
                                                :key="option.id"
                                                :label="option.code"
                                                :value="option.id">
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </b-col>
                                <b-col lg="2">
                                    <base-input v-model="receipt.amount" :label="language_terms['PAYMENT_AMOUNT']"
                                    :placeholder="total_allocated_amount" 
                                    type="number" :disabled="!is_edit"></base-input>
                                </b-col>
                                <b-col lg="2">
                                    <base-input v-model="receipt.adjustment_amount" :label="language_terms['ADJUSTMENT_AMOUNT']"
                                        type="number" :disabled="!is_edit">
                                    </base-input> 
                                </b-col>
                                <b-col lg="2">
                                    <base-input :label="language_terms['PAYMENT_MODE']">
                                        <el-select
                                            v-model="receipt.mode"
                                            filterable
                                            :placeholder="language_terms['PAYMENT_MODE']"
                                            :disabled="!is_edit">
                                            <el-option
                                                v-for="option in payment_modes"
                                                :key="option.code"
                                                :label="language_terms[option.name]"
                                                :value="option.code">
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </b-col>
                                <b-col lg="2">
                                    <base-input v-model="receipt.reference" :label="language_terms['REFERENCE']" :disabled="!is_edit"></base-input>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col lg="12">
                                    <base-button type="primary" @click.native="allocateAmount" v-if="is_edit">
                                        {{language_terms['ALLOCATE']}}
                                    </base-button>
                                </b-col>
                            </b-row>
                            <b-row class="mt-4" v-if="receipt.items.length > 0">
                                <b-col cols="8">
                                    <h4>{{$route.params.id == '_new' ? language_terms["OUTSTANDING_INVOICES"] : language_terms["INVOICES"]}}</h4>
                                </b-col>
                                <b-col cols="4">
                                    <div class="float-right" v-if="is_edit">
                                        <span class="mr-3"><b>{{language_terms["TOTAL_OUTSTANDING_AMOUNT"]}}</b></span>
                                        <span class="text-green font-weight-bold">{{receipt.currency_prefix}}{{(total_outstanding_amount *1).toFixed(2)}}</span>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row class="mt-3" v-if="receipt.items.length > 0">
                                <b-col cols="12">
                                    <b-table-simple hover responsive>
                                        <b-thead head-variant="light">
                                            <b-th>{{language_terms['DATE']}}</b-th>
                                            <b-th>{{language_terms['INVOICE_NUMBER']}}</b-th>
                                            <b-th>{{language_terms['INVOICE_AMOUNT']}} ({{receipt.currency_prefix}})</b-th>
                                            <b-th>{{language_terms['BALANCE']}} ({{receipt.currency_prefix}})</b-th>
                                            <b-th>{{language_terms['APPLY']}} ({{receipt.currency_prefix}})</b-th>
                                            <b-th></b-th>
                                        </b-thead>
                                        <b-tbody>
                                            <tr v-for="(invoice, i) in receipt.items" :key="i">
                                                <td>{{moment(invoice.document_date).format("DD/MM/YYYY")}}</td>
                                                <td>{{invoice.document_number}}</td>
                                                <td>{{invoice.document_nett_amount}}</td>
                                                <td>
                                                    <span v-if="(!is_edit )">{{invoice.balance}}</span>
                                                    <span v-else>{{invoice.balance_exclude ? invoice.balance_exclude : invoice.balance}}</span>
                                                <td>
                                                    <base-input v-model="invoice.amount" :placeholder="language_terms['APPLY']" type="number" v-if="is_edit"></base-input>
                                                    <span v-else>{{invoice.amount}}</span>
                                                </td>
                                                <td>
                                                    <base-button type="success" @click.native="applyFullAmount(invoice, i)" class="mr-4" v-if="is_edit">
                                                        {{language_terms['APPLY']}}
                                                    </base-button>
                                                </td>
                                            </tr>
                                        </b-tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                            <b-row class="mt-3" v-if="receipt.items.length > 0">
                                <b-col lg="12">
                                    <base-button type="success" @click.native="saveDocument" class="mr-4" v-if="is_edit">
                                        {{language_terms['SAVE']}}
                                    </base-button>
                                    <base-button type="primary" @click.native="cancel">
                                        {{language_terms['BACK']}}
                                    </base-button>
                                </b-col>
                            </b-row>
                        </card>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import { mapState } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import { Select, Option} from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import moment from "moment";
import Vue from 'vue'
import printDocument from "./printReceipt.vue"
import BaseInput from '../../components/Inputs/BaseInput.vue';

export default {
  props: {
    type: 
    {
      type: String,
      default: "SALES",
      description: "Receipt Type",
      required: true,
    }
  },
  components:{
    Loading,
    [Select.name]: Select,
    flatPicker,
    [Option.name]: Option,
    printDocument,
    BaseInput
  },
  computed: {
    ...mapState({
        language_terms: (state) => state.languages.language_terms,
        selected_lang: (state) => state.languages.selected_langauge,
        outstanding_sales_invoices: (state) => state.sales.outstanding_sales_invoices,
        currency_prefix: (state) => state.currencies.prefix,
        is_receipt_created: (state) => state.receipts.is_created,
        is_receipt_updated:(state) => state.receipts.is_updated,
        receipt_is_voided: (state) => state.receipts.is_voided,
        receipt_filter: (state) => state.receipts.filter,
        receipt_data: (state) => state.receipts.data,
        company_bankaccounts: (state) => state.bankAccounts.company_bankaccounts
    }),
    total_outstanding_amount: function() {
            if (!this.receipt.items) {
                return 0;
            }
            return this.receipt.items.reduce(function (total, value) {
                let balance_amount = (value.balance_exclude ? value.balance_exclude  : value.balance)
                total = total + Number(balance_amount);
                return parseFloat(total.toFixed(2));
            }, 0);
    },
    total_allocated_amount: function()
    {
            if (!this.receipt.items) {
                return 0;
            }
            return this.receipt.items.reduce(function (total, value) {
                total = (total + Number(value.amount)) * 1
                return parseFloat(total.toFixed(2));
            }, 0);
    }
  },
  data(){
      return{
          loading:false,
          document_title:"",
          customers:[],
          payment_modes:[
              {code:"CASH", name:"CASH"},
              {code:"BANK_TRANSFER", name:"BANK_TRANSFER"},
              {code:"CHEQUE", name:"CHEQUE"}
          ],
          is_edit:false,
          receipt:{
              time_printed:null,
              is_void:null,
              customer:{},
              currency_code:"",
              contact_id:'',
              contact_code:'',
              contact_name:'',
              items:[],
              amount:null,
              adjustment_amount:0,
              mode:'CHEQUE',
              reference:'',
              remarks:"",
              currency_prefix:'',
              bankaccount_id:''
          }
      }
  },
  async mounted()
  { 

      this.loading = true
      let document_id = this.$route.params.id;

      if(document_id == '_new')
      {
        this.is_edit = true
        this.document_title = this.language_terms['NEW'] + " " + (this.type == 'SALES' ? this.language_terms['SALES_RECEIPT'] : this.language_terms['PURCHASE_RECEIPT'] )

        if(!this.receipt.date)
        {
            this.receipt.date = moment().format("YYYY-MM-DD");
        }
      }
      else
      {
          this.is_edit = false
          await this.retrieveDocument(document_id)
          this.document_title = this.receipt.code

            await this.asyncFindCustomer(this.receipt.contact_code);

            let selected_customer = {
                id: this.receipt.contact_id,
                code: this.receipt.contact_code,
                name: this.receipt.contact_name,
            };

            this.receipt.customer = selected_customer;

            if(this.receipt.currency_code)
            {
                await this.$store.dispatch("currencies/getPrefix", {currency_code:this.receipt.currency_code})
                await this.$store.dispatch("bankAccounts/fetchCompanyAccounts", {currency_code:this.receipt.currency_code})
            }

      }


      this.loading = false
  },
  methods:
  {
    applyFullAmount(invoice, i)
    {
        invoice.amount = invoice.balance

        
        this.$set(this.receipt.items, i , invoice) 

    },
    saveDocument()
    {
        if(this.$route.params.id == '_new')
        {
            this.create()
        }
        else
        {
            this.update()
        }
    },
    async voidDocument()
    {
        await this.$store.dispatch("receipts/void", {"id": this.receipt.id})

        if(this.receipt_is_voided)
        {
            await this.searchReceipts()
            await this.routeToMaster();
        }
    },
    editDocument()
    {
        this.is_edit = 1
    },
    moment: function () {
        return moment();
    },
    async retrieveDocument(code) 
    {
      await this.$store.dispatch("receipts/fetch", {code: code,type: this.type});
      this.receipt = this.receipt_data;
    },
    async update()
    {
        this.receipt.type = this.type

        await this.$store.dispatch("receipts/update", this.receipt)

        if(this.is_receipt_updated)
        {
            await this.searchReceipts()
            await this.routeToMaster();
        }

    },
    async create()
    {
        this.receipt.type = this.type
        await this.$store.dispatch("receipts/create", this.receipt)

        if(this.is_receipt_created)
        {
            await this.searchReceipts()
            await this.routeToMaster();
        }
    },
    routeToMaster() 
    {
      if (this.type == "SALES") 
      {
        this.$router.push("/sales/sales-receipts");
      } 
      else if (this.type == "SO") 
      {
      } 

    },
    cancel()
    {
        this.$router.push("/sales/sales-receipts")
    },
    allocateAmount()
    {
        let allocate_amount = parseFloat(this.receipt.amount) + parseFloat(this.receipt.adjustment_amount)
        if(allocate_amount && allocate_amount <= this.total_outstanding_amount)
        {
            if(this.receipt.items.length > 0)
            {
                let amount = (allocate_amount * 1)
                for(let i = 0; i < this.receipt.items.length; i++)
                {
                    let balance_amount = this.receipt.items[i].balance_exclude ? (this.receipt.items[i].balance_exclude * 1) : (this.receipt.items[i].balance * 1) 
                    this.receipt.items[i].amount = null
                    if(amount > 0)
                    {                        

                        if(amount > balance_amount)
                        {
                            this.receipt.items[i].amount =  parseFloat(balance_amount.toFixed(2));
                        }
                        else
                        {
                            this.receipt.items[i].amount = parseFloat(amount.toFixed(2));
                        }
                        amount = amount - this.receipt.items[i].amount
                    }
                }
            }
        }
        else
        {
            Vue.notify({
                group: "notify",
                type: "error",
                text: "Invalid Payment Amount",
                max: 5,
                duration: 5000,
                speed: 300,
              });
        }
    },
    async searchReceipts()
    {
        this.loading = true
        let filter = {
                        keyword:"",
                        date_from:null,
                        date_to:null,
                      }
        if(this.receipt_filter)
        {
            filter = this.receipt_filter
        }
        await this.$store.dispatch('receipts/quickSearch', filter)

        this.loading = false
    },
    async onSelectCustomer(selectedOption)
    {
        if(selectedOption)
        {
            this.receipt.currency_code = selectedOption.currency_code

            if(this.$route.params.id == '_new')
            {
                await this.$store.dispatch("sales/retrieveOutstandingInvoices", {contact_id:selectedOption.id, type:this.type})
            }

            if(selectedOption.currency_code)
            {
                await this.$store.dispatch("currencies/getPrefix", {currency_code:selectedOption.currency_code})
                await this.$store.dispatch("bankAccounts/fetchCompanyAccounts", {currency_code:selectedOption.currency_code})

                if(this.company_bankaccounts.length > 0 && !this.receipt.bankaccount_id)
                {
                    this.receipt.bankaccount_id = this.company_bankaccounts[0]
                }

                this.receipt.currency_prefix = this.currency_prefix
            }
            
            if(this.type == 'SALES')
            {
                this.receipt.items = this.outstanding_sales_invoices
            }

            this.receipt.contact_id = selectedOption.id
        }
    },
    limitText(count) {
      return `and ${count} other customers`;
    },
    async asyncFindCustomer(query) 
    {
      let pv = { value: query };
      await axios.post(apiRoutes["CUSTOMER_LOOKUP"], pv, authHeader()).then((response) => {
          if (response.data.code == 1) {
            this.customers = response.data.data;
          } else {
            this.customers = [];
          }

          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response);
            Vue.notify({
              group: "notify",
              type: "error",
              text: error.response.data.msg,
              max: 5,
              duration: 5000,
              speed: 300,
            });
          } else {
            console.log("Problem submitting New Post", error);
          }
        });
    },
  }
}
</script>
